import React from "react";
import { Link } from "react-router-dom";

// NEW UI: Landing-page-only navigation; shared application navigation remains unchanged.
export default function LandingHeader() {
  return <nav className="landing-nav" aria-label="Main navigation">
    <a className="landing-brand" href="#top">Grant<span>AI</span>de</a>
    <div className="landing-nav-links">
      <a href="#features">Features</a><a href="#how">How it works</a><a href="#pricing">Pricing</a><a href="#faq">FAQ</a>
      {/* <Link className="nav-signin" to="/login">Sign In</Link><Link className="nav-cta" to="/signup">Sign Up</Link> */}
      <Link className="nav-signin" to="/login">Sign In</Link><a className="nav-cta" href="#pricing">Choose a plan</a>
    </div>
  </nav>;
}
